import { render } from "./elTablenopagination2.vue?vue&type=template&id=e5d4129e&scoped=true"
import script from "./elTablenopagination2.vue?vue&type=script&lang=js"
export * from "./elTablenopagination2.vue?vue&type=script&lang=js"

import "./elTablenopagination2.vue?vue&type=style&index=0&id=e5d4129e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d4129e"]])

export default __exports__